import React from 'react'
import config from 'config'
import scriptLoader from 'react-async-script-loader'

const withRateScript = WrappedComponent => {
  const WithRateScript = props => <WrappedComponent {...props} />

  WithRateScript.displayName = `${WrappedComponent.displayName}WithRateScript`
  return scriptLoader(config.ratesLibraryUrl)(WithRateScript)
}

export default withRateScript
